import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_PROGRAM_PERFORMANCE_CHART_GET_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_PROGRAM_PERFORMANCE_CHART_GET_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_PROGRAM_PERFORMANCE_CHART_GET_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/user-programs/${id}/performance-chart`,
    method: 'GET',
  })
);

export default apiCall;
